import WrappedPicker from '../WrappedPicker';
import { useCatalogueLocale } from './useCatalogueLocale';
export default function IndustryPicker({ value, onChange }: { value: string; onChange: (value: string) => void }) {
 const { data, t } = useCatalogueLocale();
 const choices = [{ id: '', name: t('All industries'), count: data.apps.length }, ...data.industries.map(industry => ({ ...industry, count: data.apps.filter(app => app.industry === industry.id).length }))];
 return <WrappedPicker placeholder={t('Choose an option')} label={t('Industry')} value={value} onChange={onChange} choices={choices} />;
}
